export enum NumberDirection {
  left = -1,
  none = 0,
  right = 1,
}
